const words = [
  { name: 'wembley', sport: 'football' },
  { name: 'twickenham', sport: 'rugby' },
  { name: 'lords', sport: 'cricket' },
  { name: 'anfield', sport: 'football' },
  { name: 'murrayfield', sport: 'rugby' },
  { name: 'headingley', sport: 'cricket' },
];

export default words;
